/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const toggleDividendsReinvestPostRequestSchema = z.object({
  investment_product: z.string(),
});
